export namespace SERVER_HOST {
    export const MEDIA = ""
}
